const oldPortalUrl = 'https://mars-manage.fieldassist.io/';
const dashboardAPIUrl = 'https://fadashboardv2-mars.azurewebsites.net/';
//const dashboardAPIUrl = 'https://localhost:5001/';


export {
    oldPortalUrl,
    dashboardAPIUrl,
}